export const ADVERSE_MEDIA_CATEGORIES = [
  {
    key: "political",
    label: "Political",
    emptyMessage: "No political exposure records found",
  },
  {
    key: "regulatory",
    label: "Regulatory",
    emptyMessage: "No regulatory exposure records found",
  },
  {
    key: "terrorism",
    label: "Terrorism",
    emptyMessage: "No terrorism records found",
  },
  {
    key: "financial_crime",
    label: "Financial Crime",
    emptyMessage: "No financial crime records found",
  },
  {
    key: "organized_crime",
    label: "Organized Crime",
    emptyMessage: "No organized crime records found",
  },
  {
    key: "violent_crime",
    label: "Violent Crime",
    emptyMessage: "No violent crime records found",
  },
];

export function getAdverseMediaCategoryLabel(key: string): string {
  const match = ADVERSE_MEDIA_CATEGORIES.find((c) => c.key === key);
  return match ? match.label : key;
}

/** Sum hits from news_exposures categories; do not use outer total_hits. */
export function getAdverseMediaTotalHits(result: any): number {
  const exposures = result?.news_exposures;
  if (!exposures || typeof exposures !== "object") {
    return 0;
  }

  return Object.keys(exposures).reduce((sum, key) => {
    const hits = Number(exposures[key]?.hits || 0);
    return sum + (isNaN(hits) ? 0 : hits);
  }, 0);
}

/** Articles actually returned in the API response for one category. */
export function getAdverseMediaCategoryReturnedCount(exposure: any): number {
  if (!exposure || !Array.isArray(exposure.articles)) {
    return 0;
  }
  return exposure.articles.length;
}

export function resolveAdverseMediaExposures(result: any): Record<string, any> | null {
  if (!result) {
    return null;
  }
  if (result.news_exposures && typeof result.news_exposures === "object") {
    return result.news_exposures;
  }
  if (
    result.adverseMediaData &&
    result.adverseMediaData.news_exposures &&
    typeof result.adverseMediaData.news_exposures === "object"
  ) {
    return result.adverseMediaData.news_exposures;
  }
  return null;
}

/** Sum of returned articles across all categories. */
export function getAdverseMediaTotalReturnedCount(result: any): number {
  if (result && typeof result.returned_article_count === "number") {
    return result.returned_article_count;
  }

  const exposures = resolveAdverseMediaExposures(result);
  if (!exposures) {
    return 0;
  }

  return ADVERSE_MEDIA_CATEGORIES.reduce((sum, category) => {
    return sum + getAdverseMediaCategoryReturnedCount(exposures[category.key]);
  }, 0);
}
